import type { CSSProperties } from 'react'
import CheckRoundedIcon from '@mui/icons-material/CheckRounded'
import DoneAllRoundedIcon from '@mui/icons-material/DoneAllRounded'
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded'
import PauseCircleOutlineRoundedIcon from '@mui/icons-material/PauseCircleOutlineRounded'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import { useNls } from '../../nls/nlsProvider'
import { whatsappStatusView } from '../../utils/whatsappChat'
import type { ChatWhatsappStatus } from '../../types/chat'
import './deliveryTicks.css'

export type DeliveryTicksProps = {
  status: ChatWhatsappStatus | string | undefined
  className?: string
  style?: CSSProperties
  size?: 'sm' | 'md'
  testId?: string
}

export const DeliveryTicks = ({
  status,
  className = '',
  style,
  size = 'sm',
  testId = 'delivery-ticks',
}: DeliveryTicksProps) => {
  const { t } = useNls()
  const { tickKind, nlsKey } = whatsappStatusView(status)
  const label = t(nlsKey)
  const fontSize = size === 'sm' ? 14 : 18

  const renderIcon = () => {
    switch (tickKind) {
      case 'sending':
        return (
          <span
            className="deliveryTicks__spinner"
            style={{ width: fontSize - 2, height: fontSize - 2 }}
          />
        )
      case 'sent':
        return <CheckRoundedIcon sx={{ fontSize }} />
      case 'delivered':
        return <DoneAllRoundedIcon sx={{ fontSize }} />
      case 'read':
        return <DoneAllRoundedIcon sx={{ fontSize }} />
      case 'held':
        return <AccessTimeRoundedIcon sx={{ fontSize }} />
      case 'paused':
        return <PauseCircleOutlineRoundedIcon sx={{ fontSize }} />
      case 'failed':
      default:
        return <ErrorOutlineRoundedIcon sx={{ fontSize }} />
    }
  }

  return (
    <span
      className={`deliveryTicks deliveryTicks--${tickKind} ${className}`.trim()}
      style={style}
      aria-label={label}
      title={label}
      data-testid={testId}
      data-tick-kind={tickKind}
    >
      {renderIcon()}
    </span>
  )
}
